import axios from "axios";

const BASE_URL = "https://vogelkoparchitects.com/api/api/";

export const CreateContact = async (formData) => {
  const response = await axios.post(`${BASE_URL}contact/`, formData);
  return response.data;
};
